const BlogsIcon = ({ width = 16, height = 16, fill = "#374151" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M3 1C2.44687 1 2 1.44687 2 2V14C2 14.5531 2.44687 15 3 15H13C13.5531 15 14 14.5531 14 14V2C14 1.44687 13.5531 1 13 1H3ZM1 2C1 0.896875 1.89688 0 3 0H13C14.1031 0 15 0.896875 15 2V14C15 15.1031 14.1031 16 13 16H3C1.89688 16 1 15.1031 1 14V2ZM4.5 4.5H11.5C11.775 4.5 12 4.725 12 5C12 5.275 11.775 5.5 11.5 5.5H4.5C4.225 5.5 4 5.275 4 5C4 4.725 4.225 4.5 4.5 4.5ZM4.5 7.5H11.5C11.775 7.5 12 7.725 12 8C12 8.275 11.775 8.5 11.5 8.5H4.5C4.225 8.5 4 8.275 4 8C4 7.725 4.225 7.5 4.5 7.5ZM4.5 10.5H6.5C6.775 10.5 7 10.725 7 11C7 11.275 6.775 11.5 6.5 11.5H4.5C4.225 11.5 4 11.275 4 11C4 10.725 4.225 10.5 4.5 10.5Z"
      fill={fill}
    />
  </svg>
);

export default BlogsIcon;
